module.exports = __webpack_public_path__ + "img/feature-graph.f24b0819.png";